import { useMemo } from 'react';
import { Tag } from 'antd';
import { MedicineBoxOutlined, ExperimentOutlined, HeartOutlined, MoreOutlined } from '@ant-design/icons';

export const useServiceTypeRender = () => {
  return useMemo(() => {
    return (serviceType: string) => {
      const serviceConfigs: {
        [key: string]: { 
          icon: React.ReactNode; 
          text: string; 
          bgColor: string;
          textColor: string;
          borderColor: string;
        };
      } = {
        CONSULTATION: {
          icon: <MedicineBoxOutlined />,
          text: 'Consultation',
          bgColor: '#e6f7ff',
          textColor: '#096dd9',
          borderColor: '#91d5ff',
        },
        TREATMENT: {
          icon: <ExperimentOutlined />,
          text: 'Treatment',
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#b7eb8f',
        },
        LHR_TREATMENT: {
          icon: <HeartOutlined />,
          text: 'LHR Treatment',
          bgColor: '#f9f0ff',
          textColor: '#531dab',
          borderColor: '#d3adf7',
        },
        OTHER: {
          icon: <MoreOutlined />,
          text: 'Other',
          bgColor: '#f5f5f5',
          textColor: '#595959',
          borderColor: '#d9d9d9',
        },
      };

      const config = serviceConfigs[serviceType] || {
        icon: <MoreOutlined />,
        text: serviceType || 'Unknown',
        bgColor: '#fafafa',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    };
  }, []);
};
